// Libs
import PropTypes from 'prop-types';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';

// Constants
import { SESSION_STORAGE_CURRENT_PATH } from '@/common/constants';
// Services
import SessionStoragePath from '@/common/services/SessionStorage.path';

const PathContext = createContext(null);

export const PathContextProvider = ({ children }) => {
  const location = useLocation();
  const pathService = SessionStoragePath.getService();

  const storagePathValue = useCallback(() => {
    const prevPath = sessionStorage.getItem(SESSION_STORAGE_CURRENT_PATH) || '';
    const currentPath = `${location.pathname}${location.search}`;

    pathService.setPath(currentPath, prevPath);
  }, [location, pathService]);

  useEffect(() => {
    storagePathValue();
  }, [location, storagePathValue]);

  return (
    <PathContext.Provider value={{ storagePathValue }}>
      {children}
    </PathContext.Provider>
  );
};

export const usePathContext = () => useContext(PathContext);

PathContextProvider.defaultProps = {};

PathContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
